import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import { Snackbars } from 'reactApp/ui/Snackbars/Snackbars';

const el = document.getElementById('react-snackbars');
let SnackbarsComponent;

if (!SnackbarsComponent) {
    SnackbarsComponent = new BReactComponent({
        ReactComponent: Snackbars,
        renderMode: 'append',
    });
}

app.on('page:start', () => {
    if (el) {
        SnackbarsComponent.renderTo(el);
    }
});
